// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"17c8e3fa","364":"e21511d0","372":"a11cb5ae","441":"d2faa46e","442":"987c960a","538":"6494d6a3","561":"0d3110dd","591":"a33ceafb","810":"472dc3fc","843":"45359ab0","955":"397fad33"}[chunkId] + ".chunk.js";
};